






















































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import PlantSearch from '@/app/components/Plant/PlantSearch.vue'
import PlantListHeader from '@/app/components/Plant/PlantListHeader.vue'
import PlantList from '@/app/components/Plant/PlantList.vue'
import Pagination from '@/app/components/Common/Pagination.vue'
/* api */
import PlantListApi from '@/app/model/api/plantListApi'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { routerPath, userType, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    Loading,
    ErrorModal,
    PlantSearch,
    PlantListHeader,
    PlantList,
    Pagination
  }
})
export default class plant extends Vue {
  private defaultplantData: any[] = []
  private plantData: any = {}
  private totalCount: number = 0
  private currentPage: number = 1
  private notDataMessage: boolean = false
  private showList: boolean = false
  private showLoading: boolean = true
  private isRequesting: boolean = false
  private complateMessage: string = this.$store.state.alertState.message

  created () {
    this.getplantList()
  }

  private getplantList () {
    (async () => {
      this.isRequesting = true
      /* 初期表示は名前の昇順 */
      const data = {
        year: this.$store.state.plantState.selectedYear,
        season: this.$store.state.plantState.selectedSeason,
        is_all_plantings: this.$store.state.plantState.isAllPlantings,
        word: this.$store.state.plantState.searchText,
        order_name: this.$store.state.plantState.orderName,
        sort: this.$store.state.plantState.sortAsc,
        page: this.$store.state.plantState.currentPage
      }
      this.currentPage = this.$store.state.plantState.currentPage

      const result = await PlantListApi.getPlantList(data)

      if (result.isOk()) {
        this.plantData = result.getPayload()
        this.totalCount = result.getPayload().total_count

        if (this.totalCount === 0) {
          this.notDataMessage = true
        } else {
          this.notDataMessage = false
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
      this.isRequesting = false
    })()
  }

  private scrollTop () : any {
    let plantArea: any = document.getElementById('listContainer')!
    plantArea.scrollTop = 0
  }

  private changeList () {
    this.isRequesting = true
    this.showLoading = true
    /* 1ページ目に戻る */
    const pagination: any = this.$refs.pagination
    pagination.resetCurrentPage()
    this.scrollTop()

    this.$store.commit('plantState/setCurrentPage', 1)
    this.$store.commit('plantState/setOrderName', 'created_at')
    this.$store.commit('plantState/setSortAsc', false)

    this.getplantList()
  }

  private doPlantSort (data: string) {
    this.isRequesting = true
    this.showLoading = true
    /* 1ページ目に戻る */
    const pagination: any = this.$refs.pagination
    pagination.resetCurrentPage()
    this.scrollTop()

    let sort = false
    if (data === this.$store.state.plantState.orderName) {
      if (this.$store.state.plantState.sortAsc === true) {
        sort = false
      } else {
        sort = true
      }
    } else {
      sort = true
    }

    this.$store.commit('plantState/setCurrentPage', 1)
    this.$store.commit('plantState/setOrderName', data)
    this.$store.commit('plantState/setSortAsc', sort)
    this.getplantList()
  }

  private onPageChange (page: number) {
    if (!this.isRequesting) {
      this.showLoading = true
      this.scrollTop()
      this.$store.commit('plantState/setCurrentPage', page)
      this.getplantList()
    }
  }
}
